import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/pagos',
    name: 'pagos.index',
    component: () => import('./views/PagosIndex.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'pagos.read',
      breadcrumb: 'Pagos',
    },
  },
]

export default routes
